import React from 'react';

const IMAGE_DIMENSIONS = {
  '/common-interview-questions.png': { width: 2000, height: 1000 },
  '/confidence-with-interview.png': { width: 540, height: 450 },
  '/confuse-to-get-perfect-mock-interview-platform-.png': { width: 450, height: 450 },
  '/failed-Interview.png': { width: 450, height: 450 },
  '/logo-icon.svg': { width: 128, height: 128 },
  '/logo.png': { width: 297, height: 334 },
  '/practice-interview-online.png': { width: 1024, height: 1024 },
  '/sit-for-interview-after-using-tryinterview.png': { width: 450, height: 450 },
  '/successed-interview-with-tryinterview.site.png': { width: 450, height: 450 },
};

function MarketingImage({
  src,
  alt,
  className,
  priority = false,
  sizes,
}) {
  const dimensions = IMAGE_DIMENSIONS[src] || {};

  return (
    <img
      src={`${process.env.PUBLIC_URL}${src}`}
      alt={alt}
      className={className}
      width={dimensions.width}
      height={dimensions.height}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : 'low'}
      decoding="async"
      sizes={sizes}
      draggable="false"
    />
  );
}

export default MarketingImage;
